import styled from "styled-components";

const Shadow = styled.div`
 &::before {
    content: "";
    position: absolute;
    left: 10%;
    right: 10%;
    bottom: 8px;
    height: 8px;
    background: radial-gradient(50% 120% at 50% 50%, var(--glow, rgba(76,137,255,.5)) 0%, transparent 70%);
    filter: blur(8px);
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    inset: auto 0 0 0;
    height: var(--shadowH, 56px);
    background:
      radial-gradient(80% 100% at 50% 100%,
        rgba(0,0,0,.35) 0%,
        rgba(0,0,0,.25) 35%,
        rgba(0,0,0,0) 80%);
    pointer-events: none;
  }
`

export const GlowShadow = () => {
  return (
    <Shadow />
  )
}
